var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_vm._v("\n  Copyright © 2017-2020 甘肃省“互联网＋不动产登记”信息平台1 - Powered By GreatMap V1.0\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }